<template>
  <van-popup 
    v-model="dialogVisible" 
    position="bottom"
    :style="{ height: '90%' }"
    closeable
    @close="onclose"
    :close-on-click-overlay="false"
  >
    <div class="sign-canvas">
      <div class="title">用户签名：请在下方区域内签名确认</div>
      <div class="canvas-box">
        <div class="inner-box">
          <canvas 
            ref="signatureCanvas" 
            class="signature-canvas"
            @touchstart="canvasTouchStart"
            @touchmove="canvasTouchMove"
            @touchend="canvasEnd"
          ></canvas>
        </div>
      </div>
      <div class="foot-btn">
        <van-button class="reset" @click="reuseSignature">复用签名</van-button>
        <van-button class="reset" @click="resetCanvas">重新签名</van-button>
        <van-button class="confirm" type="primary" @click="confirmSign">提交</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Api from '@api/api'
import { Toast } from 'vant'

export default {
  name: 'MobileSignDialog',
  props: {
    detailInfo: {
      default: () => ({}),
      type: Object,
      required: true
    },
    signType: {
      default: '',
      type: String,
      required: true
    },
    opera: {
      default: null,
      type: [Number, String],
      required: true
    },
    porp_signatureName: {
      default: '',
      type: String,
      required: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      canvas: null,
      ctx: null,
      canvasHeight: 680,
      canvasWidth: 373,
      isDrawing: false,
      startX: 0,
      startY: 0,
      moveX: 0,
      moveY: 0,
      pointX: [],
      pointY: [],
      pointZ: [], // 0表示moveTo, 1表示lineTo
      currentApplicantIndex: 0,
      signatureName: ''
    }
  },
  methods: {
    // 获取当前签名人的姓名与证件号
    getCurrentApplicant() {
      try {
        const list = (this.detailInfo && this.detailInfo.applicantInfoList) || [JSON.parse(localStorage.getItem('applicantInfo'))] || []
        const idx = this.currentApplicantIndex || 0
        const cur = list[idx] || {}
        const name = cur.applicantName || cur.name || cur.loginName || this.signatureName || this.porp_signatureName || ''
        const idNumber = cur.identificationCard || cur.idNumber || ''
        return { name, idNumber }
      } catch (e) {
        return { name: this.signatureName || '', idNumber: '' }
      }
    },
    
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.initCanvas()
      })
    },
    
    initCanvas() {
      const canvas = this.$refs.signatureCanvas
      if (!canvas) return
      
      this.canvas = canvas
      this.ctx = canvas.getContext('2d')
      
      // 获取设备像素比
      const dpr = window.devicePixelRatio || 1
      
      // 设置画布显示尺寸（CSS像素）
      const wrapper = canvas.parentElement
      this.canvasWidth = wrapper.clientWidth
      this.canvasHeight = wrapper.clientHeight
      
      // 设置画布实际尺寸（设备像素）
      canvas.width = this.canvasWidth * dpr
      canvas.height = this.canvasHeight * dpr
      
      // 缩放绘图上下文以匹配设备像素比
      this.ctx.scale(dpr, dpr)
      
      // 设置样式
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round'
      
      // 绘制灰色底字
      this.drawBackgroundText()
      
      // 初始化路径数组
      this.pointX = []
      this.pointY = []
      this.pointZ = []
    },
    
    // 绘制灰色底字（从上往下排列，每个字顺时针旋转90度）
    drawBackgroundText() {
      if (!this.ctx) return
      
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo') || '{}')
      let name = applicantInfo.loginName || this.signatureName || this.detailInfo.caseInfo.applicantName || '张某某'
      
      // 去除空格
      const chars = name.replace(/\s+/g, '').split('')
      const charCount = chars.length
      
      if (charCount === 0) return
      
      // 将canvas高度均匀分成几块
      const blockHeight = this.canvasHeight / charCount
      const blockWidth = this.canvasWidth
      
      // 根据字数动态调整字体大小系数
      const sizeRatio = Math.max(1.0 - charCount * 0.1, 0.5)
      
      // 计算字体大小
      const maxFontByHeight = blockHeight * 0.95
      const maxFontByWidth = blockWidth * 0.95
      const fontSize = Math.floor(Math.min(maxFontByHeight, maxFontByWidth) * sizeRatio)
      
      // 设置灰色底字样式
      this.ctx.fillStyle = '#E0E0E0'
      this.ctx.font = `bold ${fontSize}px sans-serif`
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'middle'
      
      // 从上往下绘制每个字符，每个字顺时针旋转90度
      chars.forEach((char, index) => {
        const blockCenterX = this.canvasWidth / 2
        const blockCenterY = blockHeight * (index + 0.5)
        
        this.ctx.save()
        this.ctx.translate(blockCenterX, blockCenterY)
        this.ctx.rotate(Math.PI / 2) // 顺时针旋转90度
        this.ctx.fillText(char, 0, 0)
        this.ctx.restore()
      })
    },
    
    // 获取触摸位置
    getTouchPos(e) {
      const rect = this.canvas.getBoundingClientRect()
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top
      }
    },
    
    // 触摸开始
    canvasTouchStart(e) {
      e.preventDefault()
      const pos = this.getTouchPos(e)
      this.startX = pos.x
      this.startY = pos.y
      this.isDrawing = true
      
      // 记录路径点
      this.pointX.push(this.startX)
      this.pointY.push(this.startY)
      this.pointZ.push(0) // moveTo
      
      // 开始路径
      this.ctx.beginPath()
      this.ctx.moveTo(this.startX, this.startY)
    },
    
    // 触摸移动
    canvasTouchMove(e) {
      if (!this.isDrawing) return
      e.preventDefault()
      
      const pos = this.getTouchPos(e)
      this.moveX = pos.x
      this.moveY = pos.y
      
      // 记录路径点
      this.pointX.push(this.moveX)
      this.pointY.push(this.moveY)
      this.pointZ.push(1) // lineTo
      
      // 绘制线段
      this.ctx.strokeStyle = '#000000'
      this.ctx.lineWidth = 3
      this.ctx.lineTo(this.moveX, this.moveY)
      this.ctx.stroke()
    },
    
    // 触摸结束
    canvasEnd() {
      this.isDrawing = false
    },
    
    // 重新签名
    resetCanvas() {
      if (!this.ctx) return
      
      // 清空画布
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      
      // 清空路径记录
      this.pointX = []
      this.pointY = []
      this.pointZ = []
      
      // 重新绘制灰色底字
      this.drawBackgroundText()
    },
    
    // 复用签名
    async reuseSignature() {
      try {
        Toast.loading({
          message: '加载签名中...',
          forbidClick: true,
          duration: 0
        })
        
        const { name, idNumber } = this.getCurrentApplicant()
        
        if (!name || !idNumber) {
          Toast.clear()
          Toast('缺少姓名或证件号，无法查询签名')
          return
        }
        
        const resp = await Api.getSignaturePaths({ name, idNumber })
        Toast.clear()
        
        const coordinateInfo = resp?.data?.data?.coordinateInfo
        if (!coordinateInfo) {
          Toast('暂无可复用的签名')
          return
        }
        
        const signaturePaths = JSON.parse(coordinateInfo)
        if (!signaturePaths || !Array.isArray(signaturePaths) || signaturePaths.length === 0) {
          Toast('暂无可复用的签名')
          return
        }
        
        // 清空当前签名
        this.resetCanvas()
        
        // 转换并绘制签名
        this.convertAndDrawPaths(signaturePaths)
        
        Toast.success('签名复用成功')
      } catch (error) {
        Toast.clear()
        console.error('复用签名失败:', error)
        Toast('网络请求失败，请重试')
      }
    },
    
    // 将web端路径格式转换为小程序端格式并绘制
    convertAndDrawPaths(webPaths) {
      if (!webPaths || !Array.isArray(webPaths) || webPaths.length === 0) return
      
      // 清空现有路径数据
      this.pointX = []
      this.pointY = []
      this.pointZ = []
      
      // 第一步：收集所有点并旋转（不移动）
      const allPoints = []
      webPaths.forEach(path => {
        if (!Array.isArray(path) || path.length === 0) return
        
        path.forEach((point, index) => {
          // 顺时针旋转90度: (x, y) -> (-y, x)
          const rotatedX = -point.y
          const rotatedY = point.x
          allPoints.push({
            x: rotatedX,
            y: rotatedY,
            isMoveTo: index === 0
          })
        })
      })
      
      if (allPoints.length === 0) return
      
      // 第二步：计算旋转后签名的边界框
      let minX = allPoints[0].x
      let maxX = allPoints[0].x
      let minY = allPoints[0].y
      let maxY = allPoints[0].y
      
      allPoints.forEach(point => {
        minX = Math.min(minX, point.x)
        maxX = Math.max(maxX, point.x)
        minY = Math.min(minY, point.y)
        maxY = Math.max(maxY, point.y)
      })
      
      const signWidth = maxX - minX
      const signHeight = maxY - minY
      const signCenterX = minX + signWidth / 2
      const signCenterY = minY + signHeight / 2
      
      // 第三步：计算缩放比例（留10%边距）
      const targetWidth = this.canvasWidth * 0.9
      const targetHeight = this.canvasHeight * 0.9
      
      // 根据签名和画布的宽高比，选择合适的缩放比例
      const scaleX = targetWidth / signWidth
      const scaleY = targetHeight / signHeight
      const scale = Math.min(scaleX, scaleY, 1.5) // 限制最大放大1.5倍，避免失真
      
      // 第四步：应用缩放和居中
      const canvasCenterX = this.canvasWidth / 2
      const canvasCenterY = this.canvasHeight / 2
      
      allPoints.forEach(point => {
        // 将点移到原点（相对于签名中心）
        let x = point.x - signCenterX
        let y = point.y - signCenterY
        
        // 应用缩放
        x *= scale
        y *= scale
        
        // 移动到画布中心
        x += canvasCenterX
        y += canvasCenterY
        
        this.pointX.push(x)
        this.pointY.push(y)
        this.pointZ.push(point.isMoveTo ? 0 : 1)
      })
      
      // 重绘签名
      this.redrawSignature()
    },
    
    // 重新绘制签名
    redrawSignature() {
      if (!this.ctx || !this.pointX || this.pointX.length === 0) return
      
      // 清空 canvas（保留背景文字）
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)
      this.drawBackgroundText()
      
      // 设置签名样式
      this.ctx.strokeStyle = '#000000'
      this.ctx.lineWidth = 3
      this.ctx.lineCap = 'round'
      this.ctx.lineJoin = 'round'
      
      // 绘制所有路径
      this.ctx.beginPath()
      for (let i = 0; i < this.pointX.length; i++) {
        if (this.pointZ[i] === 0) {
          this.ctx.moveTo(this.pointX[i], this.pointY[i])
        } else {
          this.ctx.lineTo(this.pointX[i], this.pointY[i])
        }
      }
      this.ctx.stroke()
    },
    
    // 确认签名
    async confirmSign() {
      // 检查用户是否已经签名
      if (!this.pointX || this.pointX.length === 0) {
        Toast('请先进行签名')
        return
      }
      
      try {
        Toast.loading({
          message: '正在处理...',
          forbidClick: true,
          duration: 0
        })
        
        // 保存签名路径数据到后端（供复用）
        await this.saveSignaturePaths()
        
        // 导出纯净签名
        const pureSignatureData = await this.exportPureSignature()
        
        // 上传签名到服务器
        const uploadResult = await this.uploadSignature(pureSignatureData)
        
        // 生成文书
        await this.generateDocument(uploadResult)
      } catch (error) {
        Toast.clear()
        console.error('签名处理失败:', error)
        Toast('操作失败，请重试')
      }
    },
    
    // 保存签名路径数据到后端
    async saveSignaturePaths() {
      const { name, idNumber } = this.getCurrentApplicant()
      
      if (!name || !idNumber) {
        console.warn('缺少姓名或证件号，跳过保存签名路径')
        return
      }
      
      // 将小程序端格式转换为 web 端格式
      const webPaths = this.convertToWebPaths()
      
      if (!webPaths || webPaths.length === 0) {
        console.warn('签名路径为空，跳过保存')
        return
      }
      
      try {
        await Api.saveSignaturePaths({
          name,
          idNumber,
          coordinateInfo: JSON.stringify(webPaths)
        })
      } catch (error) {
        console.warn('签名路径保存失败（不影响提交流程）:', error)
      }
    },
    
    // 将小程序端格式转换为 web 端格式
    convertToWebPaths() {
      if (!this.pointX || this.pointX.length === 0) return []
      
      // 计算签名的边界框
      let minX = this.pointX[0]
      let maxX = this.pointX[0]
      let minY = this.pointY[0]
      let maxY = this.pointY[0]
      
      for (let i = 1; i < this.pointX.length; i++) {
        minX = Math.min(minX, this.pointX[i])
        maxX = Math.max(maxX, this.pointX[i])
        minY = Math.min(minY, this.pointY[i])
        maxY = Math.max(maxY, this.pointY[i])
      }
      
      const signWidth = maxX - minX
      const signHeight = maxY - minY
      const centerX = minX + signWidth / 2
      const centerY = minY + signHeight / 2
      
      const webPaths = []
      let currentPath = []
      
      for (let i = 0; i < this.pointX.length; i++) {
        // 1. 将点移到原点（相对于签名中心）
        let x = this.pointX[i] - centerX
        let y = this.pointY[i] - centerY
        
        // 2. 逆时针旋转90度: (x, y) -> (y, -x)
        const rotatedX = y
        const rotatedY = -x
        
        const point = { x: rotatedX, y: rotatedY }
        
        if (this.pointZ[i] === 0) {
          // moveTo - 开始新路径
          if (currentPath.length > 0) {
            webPaths.push(currentPath)
          }
          currentPath = [point]
        } else {
          // lineTo - 继续当前路径
          currentPath.push(point)
        }
      }
      
      // 添加最后一个路径
      if (currentPath.length > 0) {
        webPaths.push(currentPath)
      }
      
      return webPaths
    },
    
    // 导出纯净签名（不包含灰色底字）
    exportPureSignature() {
      return new Promise((resolve, reject) => {
        try {
          // 创建临时canvas
          const tempCanvas = document.createElement('canvas')
          
          // 设置尺寸（旋转后宽高对调）
          tempCanvas.width = this.canvasHeight
          tempCanvas.height = this.canvasWidth
          
          const tempCtx = tempCanvas.getContext('2d')
          
          // 白色背景
          tempCtx.fillStyle = '#FFFFFF'
          tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)
          
          // 绘制旋转和缩放后的签名
          this.drawRotatedAndScaledSignature(tempCtx, tempCanvas.width, tempCanvas.height)
          
          // 转换为base64
          const base64Data = tempCanvas.toDataURL('image/png')
          resolve(base64Data)
        } catch (error) {
          reject(error)
        }
      })
    },
    
    // 在指定context上绘制旋转和缩放后的签名
    drawRotatedAndScaledSignature(ctx, canvasWidth, canvasHeight) {
      // 计算签名的边界框
      let minX = this.pointX[0]
      let maxX = this.pointX[0]
      let minY = this.pointY[0]
      let maxY = this.pointY[0]
      
      for (let i = 1; i < this.pointX.length; i++) {
        minX = Math.min(minX, this.pointX[i])
        maxX = Math.max(maxX, this.pointX[i])
        minY = Math.min(minY, this.pointY[i])
        maxY = Math.max(maxY, this.pointY[i])
      }
      
      const signWidth = maxX - minX
      const signHeight = maxY - minY
      const centerX = minX + signWidth / 2
      const centerY = minY + signHeight / 2
      
      // 获取当前签名人姓名，计算字符数
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo') || '{}')
      const name = applicantInfo.loginName || this.signatureName || this.detailInfo.caseInfo.applicantName || '张某某'
      const charCount = name.replace(/\s+/g, '').length || 3
      
      // 计算目标区域
      const blockHeight = this.canvasHeight / charCount
      const blockWidth = this.canvasWidth
      const sizeRatio = Math.max(1.0 - charCount * 0.1, 0.5)
      const maxFontByHeight = blockHeight * 0.95
      const maxFontByWidth = blockWidth * 0.95
      const targetSize = Math.floor(Math.min(maxFontByHeight, maxFontByWidth) * sizeRatio)
      
      // 计算缩放比例
      const scaleX = (this.canvasHeight * 0.8) / signWidth
      const scaleY = (targetSize * charCount * 0.9) / signHeight
      const scale = Math.min(scaleX, scaleY)
      
      // 设置签名样式
      ctx.strokeStyle = '#000000'
      ctx.lineWidth = 3
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
      
      // 绘制所有路径（逆时针旋转90度+缩放）
      ctx.beginPath()
      for (let i = 0; i < this.pointX.length; i++) {
        // 1. 将点移到原点（相对于签名中心）
        let x = this.pointX[i] - centerX
        let y = this.pointY[i] - centerY
        
        // 2. 应用缩放
        x *= scale
        y *= scale
        
        // 3. 逆时针旋转90度: (x, y) -> (y, -x)
        const rotatedX = y
        const rotatedY = -x
        
        // 4. 移动到画布中心
        const finalX = rotatedX + canvasWidth / 2
        const finalY = rotatedY + canvasHeight / 2
        
        if (this.pointZ[i] === 0) {
          ctx.moveTo(finalX, finalY)
        } else {
          ctx.lineTo(finalX, finalY)
        }
      }
      ctx.stroke()
    },
    
    // 将base64转换为Blob对象
    base64ToBlob(base64Data) {
      const parts = base64Data.split(';base64,')
      const contentType = parts[0].split(':')[1]
      const raw = window.atob(parts[1])
      const rawLength = raw.length
      const uInt8Array = new Uint8Array(rawLength)
      
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      
      return new Blob([uInt8Array], { type: contentType })
    },
    
    // 上传签名到服务器
    async uploadSignature(base64Data) {
      const blob = this.base64ToBlob(base64Data)
      
      let applicantInfo = JSON.parse(localStorage.getItem('applicantInfo') || '{}')
      let fileName = applicantInfo.loginName || '签名'
      
      const file = new File([blob], `${fileName}_${Date.now()}.png`, { type: 'image/png' })
      
      const formData = new FormData()
      formData.append('file', file)
      
      const caseOrderNo = localStorage.getItem('caseOrderNo') || this.$route.query.caseOrderNo || this.$route.query.number
      if (caseOrderNo) {
        formData.append('caseOrderNo', caseOrderNo)
      }
      
      formData.append('kindType', '6') // 签名文件
      
      // 申请阅卷签名上传时传 isCheckAjbc=0，其余不传
      if (this.signType === 'onlineReview') {
        formData.append('isCheckAjbc', '0')
      }
      
      const response = await Api.appletsUpload(formData)
      
      if (response.status === 200 || response.data.code === '0') {
        return response.data || response
      } else {
        throw new Error(response.message || '上传失败')
      }
    },
    
    // 生成文书
    async generateDocument(uploadResult) {
      try {
        if (this.signType === 'revoke') {
          // 撤回申请
          const params = {
            signFileUrl: uploadResult.data.showPath,
            caseOrderNo: this.detailInfo.caseInfo.caseOrderNo,
            caseSource: 5,
            withdrawSource: +this.$route.query.searchType + 1
          }
          
          const response = await Api.WithdrawApplyExportWord(params)
          
          if (response.status === 200 && response.data) {
            Toast.clear()
            this.dialogVisible = false
            
            this.$emit('signature-submit', {
              data: response.data
            })
          } else {
            throw new Error(response.message || '生成文书失败')
          }
        } else if (this.signType === 'onlineReview') {
          // 在线阅卷 - 调用生成文书接口
          const params = {
            sginUrl: uploadResult.data.showPath,
            caseOrderNo: this.detailInfo.caseInfo.caseOrderNo || this.detailInfo.caseOrderNo,
            applicantName: this.detailInfo.caseInfo.applicantName || ''
          }
          
          const response = await Api.sginConfirm(params)
          
          if (response.status === 200 && response.data && response.data.code == 0) {
            Toast.clear()
            this.dialogVisible = false
            
            this.$emit('signature-submit', {
              data: response.data,
              signFileUrl: uploadResult.data.showPath
            })
          } else {
            throw new Error(response.data?.msg || response.message || '生成文书失败')
          }
        } else {
          // 申请或补正
          let params = {
            ...this.$parent.getSubmitData(),
            sign: 1
          }
          
          if (this.opera != 0) {
            params.correction = 1
          }
          
          const response = await Api.reconsiderApplyExportWord(params)
          
          if (response.status === 200 && response.data) {
            Toast.clear()
            this.dialogVisible = false
            
            this.$emit('signature-submit', {
              data: response.data
            })
          } else {
            throw new Error(response.message || '生成文书失败')
          }
        }
      } catch (error) {
        Toast.clear()
        console.error('生成文书失败:', error)
        Toast('生成申请书失败，请重试')
      }
    },
    
    // 关闭弹窗
    onclose() {
      this.dialogVisible = false
      this.currentApplicantIndex = 0
      this.pointX = []
      this.pointY = []
      this.pointZ = []
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-canvas {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding: 4vw;
  box-sizing: border-box;
}

.sign-canvas .title {
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 1.5;
  margin-bottom: 4vw;
}

.sign-canvas .canvas-box {
  flex: 1;
  background: #FFFFFF;
  border: 1px dashed #5A84F7;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-bottom: 4vw;
}

.sign-canvas .canvas-box .inner-box {
  width: 100%;
  height: 100%;
  background: #EBEBEB;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.sign-canvas .canvas-box .inner-box canvas {
  width: 100%;
  height: 100%;
  display: block;
  touch-action: none;
}

.sign-canvas .foot-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding-top: 4vw;
}

.sign-canvas .foot-btn .reset,
.sign-canvas .foot-btn .confirm {
  flex: 1;
  height: 44px;
  font-size: 15px;
  font-weight: 400;
  border-radius: 6px;
}

.sign-canvas .foot-btn .reset {
  background-color: #cbb486;
  color: #fff;
  border: none;
}

.sign-canvas .foot-btn .confirm {
  background-color: #cbb486;
  color: #FFFFFF;
  border: none;
}
</style>

